import styled from 'styled-components';

export const PencilWrapper = styled.div`
  border: 1px solid rgba(41, 45, 50, 0.3);
  border-radius: 6px;
  padding: 4px;
  cursor: pointer;
`;
export const TrashWrapper = styled.div`
  border: 1px solid rgba(255, 0, 0, 0.3);
  border-radius: 6px;
  padding: 4px;
  cursor: pointer;
`;
